import { REAGION_SOATO } from '@/common/constants/regions';
import { Button } from '@/components/ui/button';
import { format } from 'date-fns';
import { Download } from 'lucide-react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMasterApprenticesStore } from '../../../store/useMasterApprenticesStore';
import { exportTeacherStudentRepublicToExcel } from '../../../utils/exportTeacherStudentToExcel';
import { TeacherStudentHeader } from '../../header/Header';
import { TableRepublic } from './table/TableRepublic';

export const TeacherStudentRepublic: FC = () => {
  const { t } = useTranslation();
  const { masterApprenticesRepublic, masterApprenticesRepublicCachedAt } =
    useMasterApprenticesStore();

  const sortedData = useMemo(() => {
    if (!masterApprenticesRepublic) return [];
    return [...masterApprenticesRepublic].sort((a, b) => {
      const indexA = REAGION_SOATO.findIndex((item) => item.id === a.region_id);
      const indexB = REAGION_SOATO.findIndex((item) => item.id === b.region_id);
      return indexA - indexB;
    });
  }, [masterApprenticesRepublic]);

  const totals = useMemo(() => {
    if (!masterApprenticesRepublic || masterApprenticesRepublic.length === 0) {
      return {
        cotton_yield_under_60: 0,
        cotton_yield_above_30: 0,
        masters_count: 0,
        apprentices_count: 0,
      };
    }
    return masterApprenticesRepublic.reduce(
      (acc, row) => ({
        cotton_yield_under_60:
          acc.cotton_yield_under_60 + Number(row.cotton_yield_under_60 || 0),
        cotton_yield_above_30:
          acc.cotton_yield_above_30 + Number(row.cotton_yield_above_30 || 0),
        masters_count: acc.masters_count + Number(row.masters_count || 0),
        apprentices_count:
          acc.apprentices_count + Number(row.apprentices_count || 0),
      }),
      {
        cotton_yield_under_60: 0,
        cotton_yield_above_30: 0,
        masters_count: 0,
        apprentices_count: 0,
      },
    );
  }, [masterApprenticesRepublic]);

  const handleExport = async () => {
    if (sortedData.length > 0) {
      await exportTeacherStudentRepublicToExcel(sortedData, totals);
    }
  };

  return (
    <div className="flex flex-col gap-4 p-8">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <TeacherStudentHeader
            title="Respublika bo'yicha ustoz shogirdlar"
            isBack={false}
            isResponsible={false}
          />
          {masterApprenticesRepublicCachedAt && (
            <p className="text-sm text-gray-500 font-medium">
              {t('data.actual.on', {
                date: format(
                  new Date(masterApprenticesRepublicCachedAt),
                  'yyyy-MM-dd HH:mm',
                ),
              })}
            </p>
          )}
        </div>

        {sortedData.length > 0 && (
          <Button
            onClick={handleExport}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white"
          >
            <Download className="size-4" />
            Excel
          </Button>
        )}
      </div>
      <TableRepublic />
    </div>
  );
};
